import { useEffect } from "react";

export function useAutoAdvance(callback: () => void, delay: number) {
  useEffect(() => {
    const timer = setInterval(callback, delay);
    return () => clearInterval(timer);
  }, [callback, delay]);
}
